import { Validator } from '@vista-digital/validator';
import { cdnStandardAssetOptionsValidator } from '../../../validators/cdn-asset-options';
/**
 * Default Member Reward List component CDN options.
 */
export const defaultMemberRewardListCdnOptions = {
    rewardImage: { width: 600 },
    rewardThumbnail: { width: 120 }
};
/**
 * Validator for the Member Reward List component CDN options.
 */
export const memberRewardListCdnOptionsValidator = Validator.object({
    rewardImage: cdnStandardAssetOptionsValidator,
    rewardThumbnail: cdnStandardAssetOptionsValidator
});
